// src/Dashboard/pages/user/Absences/utils/absencesUtils.js

const API_BASE = process.env.REACT_APP_API_URL || "";

export const DEFAULT_ABSENCE_FORM = {
  isAbsent: false,
  returnDate: "",
  reason: "",
};

export const INFO_TEXT =
  "Pour un souci d’organisation, nous demandons aux parents de signaler les absences de plus d’un cours aux enseignants et au bureau. Merci d’avance. Pensez à ne plus signaler l’adhérent comme absent dès qu’il a repris les cours.";

export function getCurrentUserId() {
  try {
    const stored = JSON.parse(localStorage.getItem("userInfo") || "{}");

    return stored?.userId || stored?.id || null;
  } catch {
    return null;
  }
}

export function isAbsoluteUrl(value = "") {
  const url = String(value || "").trim();

  return (
    /^https?:\/\//i.test(url) ||
    url.startsWith("data:") ||
    url.startsWith("blob:")
  );
}

export function toAbsoluteMediaUrl(value = "") {
  const url = String(value || "").trim();

  if (!url) return "";

  if (isAbsoluteUrl(url)) return url;

  if (!url.startsWith("/uploads")) return url;

  const cleanBase = API_BASE.replace(/\/$/, "");

  return `${cleanBase}${url}`;
}

export function getAdherentAvatar(adherent) {
  return (
    toAbsoluteMediaUrl(
      adherent?.photo_url ||
        adherent?.photoURL ||
        adherent?.image_url ||
        adherent?.avatar
    ) || "/img/user_avatar.jpg"
  );
}

export function getInputDateFromApiDate(value) {
  if (!value) return "";

  const raw = String(value);

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  const date = new Date(raw);

  if (Number.isNaN(date.getTime())) return "";

  return date.toISOString().split("T")[0];
}

export function formatDateFR(value) {
  if (!value) return "Non précisée";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "Non précisée";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function formatShortDateFR(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export function hasAbsenceData(form) {
  return !!form?.isAbsent || !!form?.returnDate || !!String(form?.reason || "").trim();
}

export function isAdherentAbsent(adherent) {
  return !!adherent?.is_blessed || !!adherent?.date_reprise;
}

export function buildAbsenceNote({ returnDate, reason }) {
  const today = new Date().toLocaleDateString("fr-FR");
  const formattedReturnDate = returnDate ? formatShortDateFR(returnDate) : "non précisée";

  return `Absence signalée le ${today} jusqu'au ${formattedReturnDate} : ${
    String(reason || "").trim() || "—"
  }`;
}

export function buildReturnNote() {
  const today = new Date().toLocaleDateString("fr-FR");

  return `Reprise signalée le ${today}`;
}

export function splitNotes(notes = "") {
  return String(notes || "")
    .split("|")
    .map((item) => item.trim())
    .filter(Boolean)
    .reverse();
}

export function getAbsenceTone(adherent) {
  if (adherent?.is_blessed) {
    return {
      label: "Absent(e)",
      className:
        "bg-amber-100 text-amber-800 ring-amber-200 dark:bg-amber-900/40 dark:text-amber-200 dark:ring-amber-800",
    };
  }

  return {
    label: "Actif(ve)",
    className:
      "bg-emerald-100 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/40 dark:text-emerald-200 dark:ring-emerald-800",
  };
}